import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user_data')) || null,
    apiToken: localStorage.getItem('api_token') || null,
    loading: false,
    error: null
  }),
  getters: {
    isAuthenticated: (state) => Boolean(state.apiToken),
    // Alias pour la compatibilité avec le code existant
    token: (state) => state.apiToken,
    // Rôle admin : attendu via `user.role === 'admin'` (ou `user.is_admin`) renvoyé par le backend
    isAdmin: (state) => {
      const role = String(state.user?.role || state.user?.type || '').toLowerCase()
      return role === 'admin' || Boolean(state.user?.is_admin)
    }
  },
  actions: {
    // Login et configuration Axios 
    async login({ login, password }) { 
      this.loading = true 
      this.error = null 
      try { 
        // Appel login sur ton backend Guépard 
        const res = await axios.post('/login', { login, password }) 
        
        if (res.data.success) { 
          // ✅ On stocke le token exact à utiliser (flexible)
          this.apiToken = res.data.api_token || res.data.data?.api_token 
          this.user = res.data.data?.user 
 
          // 💾 Persistance pour le rechargement
          localStorage.setItem('api_token', this.apiToken)
          localStorage.setItem('user_data', JSON.stringify(this.user))

          // ✅ Mettre le header Authorization pour toutes les requêtes Axios 
          axios.defaults.headers.common['Authorization'] = `Bearer ${this.apiToken}` 
 
          return this.user 
        } else { 
          throw new Error(res.data.message || 'Erreur de connexion') 
        } 
      } catch (err) { 
        this.error = err.response?.data?.message || err.message 
        throw err 
      } finally { 
        this.loading = false 
      } 
    }, 
 
    // Rafraîchir l'utilisateur connecté 
    async fetchMe() { 
      if (!this.apiToken) return null
      try { 
        const res = await axios.get('/me') 
        this.user = res.data.data || res.data 
        localStorage.setItem('user_data', JSON.stringify(this.user))
        return this.user 
      } catch (err) { 
        console.error('Erreur rafraîchissement utilisateur:', err) 
        // Si 401, logout automatique
        if (err.response?.status === 401) this.logout()
        throw err 
      } 
    }, 
 
    logout() { 
      this.user = null 
      this.apiToken = null 
      localStorage.removeItem('api_token')
      localStorage.removeItem('user_data')
      delete axios.defaults.headers.common['Authorization'] 
    } 
  }
})

